


































































































































































































































































































































































































import { EventBus, hasElements, TypeEventBus } from '../../core/utils';
import { JourneysService } from '../../journeys/api/JourneysService';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import { isNullOrEmpty, phoneValidator } from '../../core/utils/validations';
import { MsgBox } from '../../core/components';
import Input from '../../core/components/Input.vue';
import { AuthStoreHelper, RootStoreHelper, CompanyStoreHelper, StoreHelper } from '../../core/mixins';
import { Mounted } from '../../core/decorators';
import Axios from 'axios';
import InputPhone from '../../core/components/InputPhone.vue';
@Component({
    components: { 
        MsgBox,
        Input,
        InputPhone
    }
})
export default class ModalConfiguration extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper
) {
    modalWidth: string = '650';
    processingRequest: boolean = false;
    valid: boolean = false;
    limitJourneyMinutes: boolean = false;
    limitStoppedMinutes: boolean = false;
    limitDriverRestMinutes: boolean = false;
    hoursValidation: any = [v => !!v || 'Seleccione'];
    tiempoMaximoJornadaHoras: any = '';
    tiempoCierreJornadasHoras: any = '4';
    tiempoCierreJornadasMinutos: any = '00';
    tiempoMaximoJornadaMinutos: any = '';
    tiempoMaximoParadaHoras: any = '';
    tiempoMaximoParadaMinutos: any = '';
    descansoHorasChofer: any = '8';
    descansoChoferMinutos: any = '0';
    chargeTimeInGeofence: any = '0';
    userEmail: string = '';
    userPhone: string = '';
    cancelToken: any = null;
    formRequest: any = {
        end: null,
        msg: ''
    };
    formData: any = {
        company: this.$store.getters.getSelectedCompanyById,
        max_journey_duration: 0,
        max_stop_duration: 0,
        min_driver_rest_duration: 0,
        phone_number: '',
        mail: '',
        alarm_journey_time_exceeded: false,
        alarm_time_on_load_exceeded: false,
    };
    
    hoursList: any = [
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12',
        '13',
        '14',
        '15',
        '16',
        '17',
        '18',
        '19',
        '20',
        '21',
        '22',
        '23',
        '24',
        '25',
        '26',
        '27',
        '28',
        '29',
        '30',
        '31',
        '32',
        '33',
        '34',
        '35',
        '36',
        '37',
        '38',
        '39',
        '40',
        '41',
        '42',
        '43',
        '44',
        '45',
        '46',
        '47',
        '48'
    ];
    hoursRest: any = [
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12',
        '13',
        '14',
        '15',
        '16',
        '17',
        '18',
        '19',
        '20',
        '21',
        '22',
        '23',
        '24'
    ];
    phoneValidation: any = phoneValidator;
    updateMaxTimeJourneyMinutes(value){
        this.tiempoMaximoJornadaMinutos = value;
    }
    updateMaxTimeStopsMinutes(value){
        this.tiempoMaximoParadaMinutos = value;
    }
    updateMaxTimeJourneyCloseMinutes(value){
        this.tiempoCierreJornadasMinutos = value;
    }
    updateDescansoChoferMinutes(value){
        this.descansoChoferMinutos = value;
    }
    updateChargeTimeInGeofence(value){
        this.chargeTimeInGeofence = value;
    }
    updateUserEmail(value){
        this.userEmail = value;
    }
    updateUserPhone(value){
        this.userPhone = value;
    }
    checkLimitedHoursDriver(val) {
        if (val === '24') {
            this.descansoChoferMinutos = '0';
            this.limitDriverRestMinutes = true;
        } else {
            this.limitDriverRestMinutes = false;
        }
    }
    checkLimitedHoursJourneys(val) {
        if (val === '48') {
            this.tiempoMaximoJornadaMinutos = '0';
            this.limitJourneyMinutes = true;
        } else {
            this.limitJourneyMinutes = false;
        }
    }
    checkLimitedHoursStops(val) {
        if (val === '48') {
            this.tiempoMaximoParadaMinutos = '0';
            this.limitStoppedMinutes = true;
        } else {
            this.limitStoppedMinutes = false;
        }
    }
    @Prop() visible: boolean;
    get form(): Vue & { validate: () => boolean } {
        return this.$refs.form as Vue & { validate: () => boolean };
    }
    @Watch('visible')
    checkModalVisible(value: boolean) {
        if (value) {
            this.loadModalData();
        }
    }
    loadModalData() {
        this.$_disableListenkey;
        this.limitJourneyMinutes = false;
        this.limitStoppedMinutes = false;
        this.limitDriverRestMinutes = false;
        this.cancelToken = Axios.CancelToken.source();
        JourneysService.getDataModalConfigurations(this.$store.getters.getSelectedCompanyById, this.cancelToken)
            .then(response => {
                //cargo configuracion
                this.tiempoMaximoJornadaHoras = this.getHoursAndMinutesFromMinutes(response.max_journey_duration).hours;
                this.tiempoMaximoJornadaMinutos = this.getHoursAndMinutesFromMinutes(
                    response.max_journey_duration
                ).minutes;
                this.tiempoCierreJornadasHoras = this.getHoursAndMinutesFromMinutes(
                    response.time_to_close_journey
                ).hours;
                this.tiempoCierreJornadasMinutos = this.getHoursAndMinutesFromMinutes(
                    response.time_to_close_journey
                ).minutes;
                this.tiempoMaximoParadaHoras = this.getHoursAndMinutesFromMinutes(response.max_stop_duration).hours;
                this.tiempoMaximoParadaMinutos = this.getHoursAndMinutesFromMinutes(response.max_stop_duration).minutes;
                this.descansoHorasChofer = this.getHoursAndMinutesFromMinutes(response.min_driver_rest_duration).hours;
                this.descansoChoferMinutos = this.getHoursAndMinutesFromMinutes(
                    response.min_driver_rest_duration
                ).minutes;
                this.chargeTimeInGeofence = response.time_on_load;
                this.formData.alarm_journey_time_exceeded = response.alarm_journey_time_exceeded || false;
                this.formData.alarm_time_on_load_exceeded = response.alarm_time_on_load_exceeded || false;
                this.userEmail = response.mail;
                this.userPhone = response.phone_number;
                this.checkLimitedHoursJourneys(this.tiempoCierreJornadasHoras);
                this.checkLimitedHoursJourneys(this.tiempoMaximoJornadaHoras);
                this.checkLimitedHoursStops(this.tiempoMaximoParadaHoras);
                this.checkLimitedHoursDriver(this.descansoHorasChofer);

            })
            .catch(error => {
                // window.console.log(error);
            })
    }
    emailValidation(val){
        if(isNullOrEmpty(val)){
            return 'Debe ingresar un e-mail';
        }

        if(!/.+@.+\..+/.test(val)){
            return 'E-mail inválido';
        }

        return true;
    }
    minutesValidation(val) {
        if (val === '' || val > 59 || val < 0) {
            return 'Número inválido';
        } else {
            return true;
        }
    }
    chargeTimeValidation(val) {
        if (val === '' || val < 0) {
            return 'Número inválido';
        } else {
            return true;
        }
    }
    submit() {
        if (this.form.validate()) {
            this.$_enableListenkey;
            this.processingRequest = true;
            let tiempoCierreJornada = this.getMinutesFromHoursAndMinutes(
                this.tiempoCierreJornadasHoras,
                this.tiempoCierreJornadasMinutos
            );
            let tiempoJornadaPromedio = this.getMinutesFromHoursAndMinutes(
                this.tiempoMaximoJornadaHoras,
                this.tiempoMaximoJornadaMinutos
            );
            let tiempoParadaPromedio = this.getMinutesFromHoursAndMinutes(
                this.tiempoMaximoParadaHoras,
                this.tiempoMaximoParadaMinutos
            );
            let tiempoDescansoChofer = this.getMinutesFromHoursAndMinutes(
                this.descansoHorasChofer,
                this.descansoChoferMinutos
            );
            this.formData = {
                company: this.$store.getters.getSelectedCompanyById,
                time_to_close_journey: tiempoCierreJornada,
                max_journey_duration: tiempoJornadaPromedio,
                max_stop_duration: tiempoParadaPromedio,
                min_driver_rest_duration: tiempoDescansoChofer,
                phone_number: this.userPhone,
                mail: this.userEmail,
                time_on_load: this.chargeTimeInGeofence,
                alarm_journey_time_exceeded: this.formData.alarm_journey_time_exceeded,
                alarm_time_on_load_exceeded: this.formData.alarm_time_on_load_exceeded,
            };
            let _this = this;
            JourneysService.postModalConfiguration(this.formData)
                .then(response => {
                    this.formRequest = {
                        end: true,
                        msg: 'Configuración guardada con éxito'
                    };
                    this.processingRequest = false;
                    setTimeout(() => {
                        _this.resetForm();
                        _this.closeModal();
                    }, 1500);
                })
                .catch(error => {
                    this.formRequest = {
                        end: false,
                        msg: 'No se pudo guardar la configuración. Intente nuevamente'
                    };
                    this.processingRequest = false;
                    setTimeout(() => {
                        _this.resetForm();
                    }, 1500);
                });
        }
    }
    resetForm() {
        this.formRequest = {
            end: null,
            msg: ''
        };
    }
    getMinutesFromHoursAndMinutes(hours, minutes) {
        return parseInt(hours) * 60 + parseInt(minutes);
    }
    getHoursAndMinutesFromMinutes(mins) {
        let hours = Math.floor(mins / 60);
        let minutes = mins % 60;
        return {
            hours: hours.toString(),
            minutes: minutes.toString()
        };
    }
    closeModal() {
        this.$emit('modal_visible');
    }
}
